module.exports = __webpack_public_path__ + "img/cover1.074be221.png";